import { Link } from "react-router-dom";
import type { Post } from "@/mocks/posts";
import PostCard from "@/components/feature/PostCard";

type HomeHeroProps = {
  featured: Post;
  latest: Post[];
};

export default function HomeHero({ featured, latest }: HomeHeroProps) {
  return (
    <section className="w-full border-b border-background-200">
      <div className="w-full px-4 md:px-8 py-8 md:py-12">
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mb-5">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-700 bg-accent-100 px-2.5 py-1 rounded-full">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-soft-pulse"></span>
            今日持续更新
          </span>
          <span className="text-xs text-foreground-500">2026年09月10日 · 星期四 · 今日新增 18 条爆料</span>
        </div>

        <h1 className="font-heading font-bold text-3xl md:text-5xl text-foreground-950 leading-tight max-w-4xl">
          黑吃瓜网 · 今日爆料与新瓜汇总
        </h1>
        <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-2xl leading-relaxed">
          把今天最新的娱乐话题、网友讨论与后续进展整理成清楚好读的卡片流。热门猛料持续更新，想知道今天又出了什么大瓜，在这里就能一次看完。
        </p>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6">
          <article className="lg:col-span-7 group">
            <Link
              to={`/post/${featured.id}`}
              className="block relative rounded-lg overflow-hidden border border-foreground-900/10 bg-foreground-950 cursor-pointer"
            >
              <div className="w-full h-64 md:h-[380px]">
                <img
                  src={featured.image}
                  alt={featured.imageAlt}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/35 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-[11px] px-2.5 py-1 rounded-full bg-accent-500 text-background-50 font-bold">
                    今日头条
                  </span>
                  <span className="text-[11px] px-2.5 py-1 rounded-full bg-white/15 text-background-100 backdrop-blur">
                    {featured.category}
                  </span>
                </div>
                <h2 className="font-heading font-bold text-xl md:text-3xl text-background-50 leading-snug">
                  {featured.title}
                </h2>
                <p className="mt-3 text-sm text-background-200 leading-relaxed line-clamp-2 hidden sm:block">
                  {featured.excerpt}
                </p>
                <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-background-300">
                  <span className="whitespace-nowrap">{featured.author}</span>
                  <span className="whitespace-nowrap">{featured.dateLabel}</span>
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-fire-line text-primary-300" aria-hidden="true"></i>
                    热度 {featured.heat}
                  </span>
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-time-line" aria-hidden="true"></i>
                    阅读约 {featured.readTime}
                  </span>
                </div>
              </div>
            </Link>
          </article>

          <div className="lg:col-span-5 flex flex-col">
            <div className="flex items-center justify-between mb-4">
              <h2 className="font-heading font-bold text-lg text-foreground-950 flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500 animate-soft-pulse"></span>
                最新更新
              </h2>
              <Link
                to="/breaking"
                className="text-xs font-medium text-primary-700 hover:text-primary-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                全部爆料 →
              </Link>
            </div>
            <div className="flex-1 bg-background-100 border border-background-200 rounded-lg p-4 md:p-5 flex flex-col justify-between">
              {latest.map((post) => (
                <div key={post.id} className="py-3 first:pt-0 last:pb-0 border-b border-background-200 last:border-b-0">
                  <PostCard post={post} variant="compact" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}